import React, { useState, useEffect } from 'react';
import { popupOpenService } from '../../shared/popupOpenService';
import { POPUP_KEY_DELETE_INGREDIENT } from '../../constant';
import { MODAL_SMALL_SIZE } from '../helper';
import Modal from '../Modal';
import { useTranslation } from 'react-i18next';
import { recipeSaveService } from '../../services/recipeSaveService';
import { productsService } from '../../services/productsService';
import { Button } from '@chapche/ui';

const DeleteIngredientModalContent = ({handleDelete, handleClose, ingredientCode}) => {
    const { i18n } = useTranslation();
    return (
        <>
            <h2 className="modal__title modal__title_align block__title-h3">{i18n.t('app.page.recipe.modal.deleteModal.title')}</h2>
            <p className="block__content modal__text modal__text_align">
                {i18n.t('app.page.recipe.modal.deleteModal.content')}
                {' ' + ingredientCode}?
            </p>
            <div className="modal__button-group">
                <Button variant="outline" onClick={() => handleClose(false)}>
                    {i18n.t('app.page.recipe.modal.cancel')}
                </Button>
                <Button onClick={handleDelete}>
                    {i18n.t('app.page.recipe.modal.delete')}
                </Button>
            </div>
        </>
    )
};

const DeleteIngredientPopup = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [currentIngredientId, setCurrentIngredientId] = useState('');

    const handleOpenModal = (ingredientId) => {
        setIsOpen(true);
        setCurrentIngredientId(ingredientId);
    };    
    
    useEffect(() => {
        popupOpenService.registerPopup(POPUP_KEY_DELETE_INGREDIENT, handleOpenModal);
        return () => popupOpenService.unRegisterPopup(POPUP_KEY_DELETE_INGREDIENT, handleOpenModal);
    },[]);

    const getIngredientCode = (ingredientId) => {
        const result = [];
        recipeSaveService.getRecipe().ingredient.find(it => it.id === ingredientId)
            .ingredientParts.forEach(ingredientPart => result.push(productsService.getLocalization(i18n.resolvedLanguage, ingredientPart.productCode, true, i18n)));
        return result.join(', ');
    };

    const deleteIngredient = () => {        
        setIsOpen(null);
        setCurrentIngredientId('');
        recipeSaveService.deleteIngredient(currentIngredientId);
    };

    return (
        isOpen ?
            <Modal content={<DeleteIngredientModalContent handleDelete={deleteIngredient} handleClose={setIsOpen} ingredientCode={getIngredientCode(currentIngredientId)} />} 
                handleCloseModal={setIsOpen} size={MODAL_SMALL_SIZE} />
            :
            null
    );
};

export default DeleteIngredientPopup;
